define.alias("shared/components/shared/plan-recommendation/index", "settings/components/shared/plan-recommendation/index");